import './Integration.scss';
import { useEffect, useState } from 'react';
import { CustomSwitch } from 'common/components/CustomSwitch/CustomSwitch';
import { Button } from 'common/components/Button/Button';
import { PopSide } from 'common/components/PopSide/PopSide';
import { RestApi } from 'common/services/rest-api.service';
import { Sentinel } from '../Sentinel/Sentinel';
import { Splunk } from '../Splunk/Splunk';
import Jira from '../Jira/Jira';
import { useDispatch, useSelector } from 'react-redux';
import ServiceNow from '../ServiceNow/ServiceNow';
import { NotAvailableIntegration } from '../NotAvailableIntegration/NotAvailableIntegration';
import { showError, showSuccess } from 'features/AlertSlice';
import { loadList, resetIntegrationPopup, setIntegrationDeleted } from 'features/IntegrationsSlice';
import { LinkNewTab } from 'common/components/LinkNewTab/LinkNewTab';

export function Integration(props: any) {
  const [isActive, setIsActive] = useState<boolean>(!!props.isActive);
  const [integration, setIntegration] = useState<string>('');
  const { categoryPopup, integrationDeleted } = useSelector((state: any) => state.integrations);

  const dispatch = useDispatch<any>();

  useEffect(() => {
    setIsActive(!!props.isActive);
  }, [props.isActive]);

  useEffect(() => {
    if (!!categoryPopup.length && props.data.component.toLowerCase() === categoryPopup.toLowerCase()) {
      setIntegration(props.data.component);
      dispatch(resetIntegrationPopup());
    }
  }, [categoryPopup, props.data.component, dispatch]);

  const showPopSide = () => {
    setIntegration(props.data.component);
  };

  const onClose = () => {
    if (integrationDeleted) {
      dispatch(setIntegrationDeleted(false));
      dispatch(loadList());
    }
    setIntegration('');
  };

  const onHide = () => {
    if (integrationDeleted) {
      dispatch(setIntegrationDeleted(false));
      dispatch(loadList());
    }
    setIntegration('');
  };

  function getComponent(component: string) {
    const components: any = {
      Jira: Jira,
      Splunk: Splunk,
      ServiceNow: ServiceNow,
      Sentinel: Sentinel,
      NotAvailableIntegration: NotAvailableIntegration
    };
    const Component = components[component];
    return <Component id={props.id} onClose={onClose} isEditMode={props.isExists} metadata={props.data} />;
  }

  const onChange = (e: React.ChangeEvent, isChecked: boolean) => {
    setIsActive(isChecked);
    RestApi.setData(
      `${props.data.apiPath}${props.id}/`,
      { status: isChecked ? 'active' : 'inactive' },
      'PATCH'
    ).subscribe(
      (response: any) => {
        dispatch(showSuccess(`Integration ${isChecked ? 'Activated' : 'Deactivated'} Successfully`));
      },
      error => {
        dispatch(showError(error));
        setIsActive(!isChecked);
      }
    );
  };

  return (
    <li className="Integration">
      <div className="integration-box-top">
        <div>
          <img src={`/assets/images/Integrations/${props.icon}.svg`} alt={props.data.label} />
          <h3>{props.data.label}</h3>
        </div>
        {props.isExists && props.showToggle && <CustomSwitch checked={isActive} onChange={onChange} />}
      </div>
      <div className="integration-subtitle">{props.data.text}</div>
      <div className="button-wrapper">
        <Button
          buttonStyle="secondary"
          type="button"
          size="small"
          onClick={showPopSide}
          text={props.isExists ? 'Edit' : 'Connect'}
        />
        {!!props.data.guideUrl && <LinkNewTab to={props.data.guideUrl} text={'User Guide'} />}
      </div>
      {!!integration && <PopSide onHide={onHide}>{getComponent(integration)}</PopSide>}
    </li>
  );
}
